var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "file-list-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("New Directory"),
            visible: _vm.dirDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dirDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Enter new directory name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("New directory name") },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dirDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onAddDir } },
                [_vm._v(_vm._s(_vm.$t("Confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("New File"),
            visible: _vm.fileDialogVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.fileDialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("Enter new file name") } },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("New file name") },
                    model: {
                      value: _vm.name,
                      callback: function($$v) {
                        _vm.name = $$v
                      },
                      expression: "name"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.fileDialogVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.onAddFile }
                },
                [_vm._v(_vm._s(_vm.$t("Confirm")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "file-tree-wrapper" },
        [
          _c("el-tree", {
            ref: "tree",
            staticClass: "tree",
            attrs: {
              data: _vm.computedFileTree,
              "node-key": "path",
              "highlight-current": true,
              "default-expanded-keys": _vm.expandedPaths
            },
            on: {
              "node-contextmenu": _vm.onFileRightClick,
              "node-click": _vm.onFileClick,
              "node-expand": _vm.onDirClick,
              "node-collapse": _vm.onDirClick
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var node = ref.node
                  var data = ref.data
                  return _c(
                    "span",
                    { staticClass: "custom-tree-node" },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            trigger: "manual",
                            placement: "right",
                            "popper-class": "create-item-popover",
                            "visible-arrow": false
                          },
                          on: {
                            hide: function($event) {
                              return _vm.onHideCreate(data)
                            }
                          },
                          model: {
                            value: _vm.isShowCreatePopoverDict[data.path],
                            callback: function($$v) {
                              _vm.$set(
                                _vm.isShowCreatePopoverDict,
                                data.path,
                                $$v
                              )
                            },
                            expression: "isShowCreatePopoverDict[data.path]"
                          }
                        },
                        [
                          _c("ul", { staticClass: "action-item-list" }, [
                            _c(
                              "li",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function($event) {
                                    _vm.fileDialogVisible = true
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: "file-alt",
                                    color: "rgba(3,47,98,.5)"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "action-item-text" },
                                  [_vm._v(_vm._s(_vm.$t("Create File")))]
                                )
                              ],
                              1
                            ),
                            _c(
                              "li",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function($event) {
                                    _vm.dirDialogVisible = true
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: ["fa", "folder"],
                                    color: "rgba(3,47,98,.5)"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "action-item-text" },
                                  [_vm._v(_vm._s(_vm.$t("Create Directory")))]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("ul", { staticClass: "action-item-list" }, [
                            _c(
                              "li",
                              {
                                staticClass: "action-item",
                                on: {
                                  click: function($event) {
                                    return _vm.onClickRemoveNav(data)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: {
                                    icon: ["fa", "trash"],
                                    color: "rgba(3,47,98,.5)"
                                  }
                                }),
                                _c(
                                  "span",
                                  { staticClass: "action-item-text" },
                                  [_vm._v(_vm._s(_vm.$t("Remove")))]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("template", { slot: "reference" }, [
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "item-icon" },
                                [
                                  data.is_dir
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fa", "folder"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : data.path.match(/\.py$/)
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fab", "python"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : data.path.match(/\.js$/)
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fab", "node-js"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : data.path.match(/\.(java|jar|class)$/)
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fab", "java"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : data.path.match(/\.go$/)
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fab", "go"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : data.path.match(/\.zip$/)
                                    ? _c("font-awesome-icon", {
                                        attrs: {
                                          icon: ["fa", "file-archive"],
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: {
                                          icon: "file-alt",
                                          color: "rgba(3,47,98,.5)"
                                        }
                                      })
                                ],
                                1
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "item-name",
                                  class: _vm.isActiveFile(data) ? "active" : ""
                                },
                                [_vm._v(" " + _vm._s(data.name) + " ")]
                              )
                            ])
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                }
              }
            ])
          }),
          _c(
            "div",
            { staticClass: "add-btn-wrapper" },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    trigger: "click",
                    placement: "right",
                    "popper-class": "create-item-popover",
                    "visible-arrow": false
                  }
                },
                [
                  _c("ul", { staticClass: "action-item-list" }, [
                    _c(
                      "li",
                      {
                        staticClass: "action-item",
                        on: {
                          click: function($event) {
                            _vm.fileDialogVisible = true
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: "file-alt", color: "rgba(3,47,98,.5)" }
                        }),
                        _c("span", { staticClass: "action-item-text" }, [
                          _vm._v(_vm._s(_vm.$t("Create File")))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "li",
                      {
                        staticClass: "action-item",
                        on: {
                          click: function($event) {
                            _vm.dirDialogVisible = true
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", {
                          attrs: {
                            icon: ["fa", "folder"],
                            color: "rgba(3,47,98,.5)"
                          }
                        }),
                        _c("span", { staticClass: "action-item-text" }, [
                          _vm._v(_vm._s(_vm.$t("Create Directory")))
                        ])
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-button",
                    {
                      staticClass: "add-btn",
                      attrs: {
                        slot: "reference",
                        size: "small",
                        type: "primary",
                        icon: "el-icon-plus",
                        disabled: _vm.isDisabled
                      },
                      on: { click: _vm.onEmptyClick },
                      slot: "reference"
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Add")) + " ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          !_vm.showFile
            ? _c("div", { staticClass: "file-list" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "Please select a file or click the add button on the left."
                      )
                    ) +
                    " "
                )
              ])
            : [
                _c("div", { staticClass: "top-part" }, [
                  _c(
                    "div",
                    { staticClass: "action-container" },
                    [
                      _c(
                        "el-popover",
                        {
                          attrs: { trigger: "click" },
                          model: {
                            value: _vm.isShowDelete,
                            callback: function($$v) {
                              _vm.isShowDelete = $$v
                            },
                            expression: "isShowDelete"
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "default" },
                              on: {
                                click: function() {
                                  return (this$1.isShowDelete = false)
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Cancel")) + " ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "danger" },
                              on: { click: _vm.onFileDelete }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
                          ),
                          _c(
                            "template",
                            { slot: "reference" },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-right": "10px" },
                                  attrs: {
                                    type: "danger",
                                    size: "small",
                                    disabled: _vm.isDisabled
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fa", "trash"] }
                                  }),
                                  _vm._v(" " + _vm._s(_vm.$t("Remove")) + " ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      ),
                      _c(
                        "el-popover",
                        {
                          attrs: { trigger: "click" },
                          model: {
                            value: _vm.isShowRename,
                            callback: function($$v) {
                              _vm.isShowRename = $$v
                            },
                            expression: "isShowRename"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { placeholder: _vm.$t("Name") },
                            model: {
                              value: _vm.name,
                              callback: function($$v) {
                                _vm.name = $$v
                              },
                              expression: "name"
                            }
                          }),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "warning" },
                                  on: { click: _vm.onRenameFile }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("Confirm")) + " ")]
                              )
                            ],
                            1
                          ),
                          _c("template", { slot: "reference" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-right": "10px" },
                                    attrs: {
                                      type: "warning",
                                      size: "small",
                                      disabled: _vm.isDisabled
                                    },
                                    on: { click: _vm.onOpenRename }
                                  },
                                  [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: ["fa", "redo"] }
                                    }),
                                    _vm._v(" " + _vm._s(_vm.$t("Rename")) + " ")
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            type: "success",
                            size: "small",
                            disabled: _vm.isDisabled
                          },
                          on: { click: _vm.onFileSave }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fa", "save"] }
                          }),
                          _vm._v(" " + _vm._s(_vm.$t("Save")) + " ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "file-path-container" }, [
                    _c("div", { staticClass: "file-path" }, [
                      _vm._v(_vm._s(_vm.currentPath))
                    ])
                  ])
                ]),
                _c("file-detail")
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }